<section class="ticket-content-container">
  <div class="custom-icon close" (click)="closeDialog()"></div>
  <section
    class="type-select-container"
    [ngClass]="{
      show: !(isTicketOptionSelected$ | async) && !(ticketSubmitted$ | async),
    }"
  >
    @if (!(isTicketOptionSelected$ | async)) {
      <div>
        @if (ticketFormGroup) {
          <form
            class="ticket-type-select"
            [formGroup]="ticketFormGroup"
            [ngClass]="{ 'form-submit-attempt': formSubmitAttempted }"
            autocomplete="off"
          >
            <h1>Create Ticket</h1>

            @if (
              (areServicesLoading$ | async) || (areInvoicesLoading$ | async)
            ) {
              <div class="loading-indicator">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              </div>
            }
            @if (
              !(areServicesLoading$ | async) &&
              !(areInvoicesLoading$ | async) &&
              ((services$ | async).length || (invoices$ | async).length)
            ) {
              <div class="question-wrapper">
                <div class="question">
                  What's the subject matter of your ticket?
                </div>
                <mat-form-field>
                  <mat-label>Select an option</mat-label>
                  <mat-select
                    formControlName="supportType"
                    (selectionChange)="onSupportTypeChange($event)"
                  >
                    <ng-container *ngxPermissionsOnly="Permission.SERVICES">
                      @if ((services$ | async)?.length) {
                        <ng-container>
                          <mat-option [value]="supportTypeLabel.SERVICE">
                            NOC - Service Outages or Performance Issues
                          </mat-option>
                        </ng-container>
                      }
                    </ng-container>
                    <ng-container *ngxPermissionsOnly="Permission.BILLING_READ">
                      @if ((invoices$ | async)?.length) {
                        <mat-option [value]="supportTypeLabel.BILLING">
                          Billing and Payment Inquiries
                        </mat-option>
                      }
                    </ng-container>
                    <ng-container
                      *ngxPermissionsOnly="[
                        Permission.ORDERS,
                        Permission.SERVICES,
                      ]"
                    >
                      @if ((services$ | async)?.length) {
                        <ng-container
                          *ngxPermissionsOnly="Permission.MANAGED_SECURITY"
                        >
                          <mat-option [value]="supportTypeLabel.SECURITY">
                            Managed Security Services (External Portal)
                          </mat-option>
                        </ng-container>
                        <mat-option [value]="supportTypeLabel.TOB">
                          Transfer of Services
                        </mat-option>
                      }
                    </ng-container>
                    <mat-option [value]="supportTypeLabel.CARE">
                      Service Alterations and General Inquiries
                    </mat-option>
                    <ng-container
                      *ngxPermissionsOnly="[
                        Permission.ORDERS,
                        Permission.SERVICES,
                      ]"
                    >
                      @if ((services$ | async)?.length) {
                        <mat-option [value]="supportTypeLabel.DISCONNECT">
                          Disconnect a Service
                        </mat-option>
                      }
                    </ng-container>
                  </mat-select>
                </mat-form-field>
                @if (inlineErrors.supportType) {
                  <div class="form-error">
                    <div class="custom-icon inline_error"></div>
                    {{ inlineErrors.supportType }}
                  </div>
                }
                <button class="primary-button" (click)="makeTicketSelection()">
                  Next
                </button>
              </div>
            } @else {
              @if (
                (areInvoicesLoaded$ | async) &&
                (areServicesLoaded$ | async) &&
                !(areServicesLoading$ | async) &&
                !(areInvoicesLoading$ | async)
              ) {
                <div class="question">
                  Your account does not currently have any active services.
                </div>
              }
            }
          </form>
        }
      </div>
    }
  </section>

  <section
    class="form-type-container"
    [ngClass]="{
      show: (isTicketOptionSelected$ | async) && !(ticketSubmitted$ | async),
    }"
  >
    <button class="back-button" (click)="goBack()">
      <div class="custom-icon arrow_back"></div>
      Back
    </button>
    @if (
      (isTicketOptionSelected$ | async) &&
      ticketFormGroup.value.supportType === supportTypeLabel.SERVICE
    ) {
      <app-ticket-noc
        [services]="services$ | async"
        [selectedServiceId]="selectedServiceId"
        [isLoading]="areServicesLoading$ | async"
        [isLoaded]="areServicesLoaded$ | async"
        [primaryReporters]="contacts$ | async"
        [submissionError]="hasSubmissionError$ | async"
        [isSubmitting]="isSubmitting$ | async"
        (submitNocForm)="submitNocForm($event)"
        [errorMessage]="errorMessage"
        [hideCustomerTicketNumber]="hideCustomerTicketNumber$ | async"
      ></app-ticket-noc>
    }
    @if (
      (isTicketOptionSelected$ | async) &&
      ticketFormGroup.value.supportType === supportTypeLabel.BILLING
    ) {
      <app-ticket-billing
        [invoices]="invoices$ | async"
        [isLoading]="areInvoicesLoading$ | async"
        [isLoaded]="areInvoicesLoaded$ | async"
        [submissionError]="hasSubmissionError$ | async"
        [isSubmitting]="isSubmitting$ | async"
        (submitBillForm)="submitBillForm($event)"
        [errorMessage]="errorMessage"
      ></app-ticket-billing>
    }
    @if (
      (isTicketOptionSelected$ | async) &&
      ticketFormGroup.value.supportType === supportTypeLabel.DISCONNECT
    ) {
      <app-ticket-disconnect
        [services]="services$ | async"
        [selectedServiceId]="selectedServiceId"
        [isLoading]="areServicesLoading$ | async"
        [isLoaded]="areServicesLoaded$ | async"
        [primaryReporters]="contacts$ | async"
        [disconnectReasons]="disconnectReasons$ | async"
        [submissionError]="hasSubmissionError$ | async"
        [errorMessage]="errorMessage"
        [isSubmitting]="isSubmitting$ | async"
        (submitForm)="submitOrderForm($event)"
      ></app-ticket-disconnect>
    }
    @if (
      (isTicketOptionSelected$ | async) &&
      ticketFormGroup.value.supportType === supportTypeLabel.CARE
    ) {
      <app-ticket-care
        [services]="services$ | async"
        [selectedServiceId]="selectedServiceId"
        [isLoading]="areServicesLoading$ | async"
        [isLoaded]="areServicesLoaded$ | async"
        [primaryReporters]="contacts$ | async"
        [submissionError]="hasSubmissionError$ | async"
        [errorMessage]="errorMessage"
        [isSubmitting]="isSubmitting$ | async"
        (submitCareForm)="submitCareForm($event)"
      ></app-ticket-care>
    }
    @if (
      (isTicketOptionSelected$ | async) &&
      ticketFormGroup.value.supportType === supportTypeLabel.TOB
    ) {
      <app-ticket-tob
        [services]="services$ | async"
        [selectedServiceId]="selectedServiceId"
        [isLoading]="areServicesLoading$ | async"
        [isLoaded]="areServicesLoaded$ | async"
        [primaryReporters]="contacts$ | async"
        [submissionError]="hasSubmissionError$ | async"
        [errorMessage]="errorMessage"
        [isSubmitting]="isSubmitting$ | async"
        (submitForm)="submitOrderForm($event)"
      ></app-ticket-tob>
    }
  </section>

  @if (ticketSubmitted$ | async) {
    <section class="create-ticket-container">
      <app-ticket-success
        (closed)="closeDialog()"
        [order]="createdOrder"
      ></app-ticket-success>
    </section>
  }
</section>
